/** @format */

// Authentication token keys
export const ACCESS_TOKEN_KEY = "OPTICLINIC_ACCESS_TOKEN";
export const REFRESH_TOKEN_KEY = "OPTICLINIC_REFRESH_TOKEN";
export const AUTH_STATUS_KEY = "OPTICLINIC_AUTH_STATUS";
export const USER_KEY = "OPTICLINIC_USER";
export const REMEMBER_ME_KEY = "OPTICLINIC_REMEMBER_ME";
export const USER_EMAIL_KEY = "OPTICLINIC_USER_EMAIL";
export const CONFIGURATIONS_KEY = "OPTICLINIC_CONFIGURATIONS";

// API Base URLs
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "http://127.0.0.1:8001/api";

// Feature flags / API capabilities
// Controls whether backend exposes a dedicated /auth/groups/ endpoint.
// Defaults to false to avoid 404 noise; can be enabled via VITE_HAS_GROUPS_ENDPOINT=true
export const HAS_GROUPS_ENDPOINT =
  (import.meta.env.VITE_HAS_GROUPS_ENDPOINT ?? "false") === "true";

// Token expiration buffer (in seconds)
export const TOKEN_EXPIRY_BUFFER = 60; // Refresh token 1 minute before expiry
